//React
import React from 'react';

//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as partnerAction from '../action/partnerAction';

//Material-ui


//Icon

//Part
import PartPartnerQaAnswer from './PartPartnerQaAnswer';
import PartPartnerQaQuestion from './PartPartnerQaQuestion';

//Dialog

class Comp extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      pic: props.pic,
      tab: props.tab,
  	}
  }


	render() {
    return (
			<div  style={{padding:'10px'}}>

        <div className='sub_menu' style={{maxWidth:'300px', margin:'auto'}}>
          <div className='outer'>
            <span
              className={['link', (this.state.tab === 'question') && 'selected'].join(' ')}
              onClick={ () => this.setState({tab: 'question'}) }
            >
              <div className='text' style={{padding:'10px'}}>質問</div>

            </span>
            <span
              className={['link', (this.state.tab === 'answer') && 'selected'].join(' ')}
              onClick={ () => this.setState({tab: 'answer'}) }
            >
              <div className='text' style={{padding:'10px'}}>回答</div>
            </span>
          </div>
        </div>



        {
          (this.state.tab === 'question') && (
            <PartPartnerQaQuestion
              pic={this.props.pic}
              qaQuestionCount={this.props.qaQuestionCount}
              qaQuestionAnsweredCount={this.props.qaQuestionAnsweredCount}
              qaQuestionAnsweredCountEdit={ (count) => this.props.qaQuestionAnsweredCountEdit(count) }
            />
          )
        }
        {
          (this.state.tab === 'answer') && (
            <PartPartnerQaAnswer
              pic={this.props.pic}
              qaAnswerCount={this.props.qaAnswerCount}
            />
          )
        }
			</div>
		)

	}
}

const mapStateToProps = (state) => {
	return {
    partner: state.partner,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...partnerAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
